var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.cardContainerRef,staticClass:"card-container"},[_c('img',{attrs:{"src":_vm.notification.gacha.image_path,"alt":""},on:{"load":_vm.imageLoaded,"error":_vm.imageLoaded}}),_c('p',[_vm._v(_vm._s(_vm.notification.gacha.name)+"のガチャ券を獲得！")])])
}
var staticRenderFns = []

export { render, staticRenderFns }